import React, { useState } from 'react';

const Step7HairColor = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.hairColor || null);

  const options = [
    { value: 'blonde', label: 'Blonde', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page7-Blonde.webp' },
    { value: 'brunette', label: 'Brunette', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page7-Brunette.webp' },
    { value: 'black', label: 'Black', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page7-Black.webp' },
    { value: 'red', label: 'Red', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page7-Red.webp' },
    { value: 'unnatural', label: 'Unnatural', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page7-Unnatural.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          hairColor: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-selection hair-grid">
      <h2 className="step-title">Which hair color do you find most attractive on a woman?</h2>
      <div className="options-grid">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected === option.value ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step7HairColor;